import {ALTERAR_REGISTROS_POR_PAGINA_PRESTADOR} from '../types'

export default function alterarRegistrosPorPaginaPrestador (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_PRESTADOR,
    payload: valor
  }
}
